<aside *ngIf="!env.USE_TAILWIND">
    <div class="block__left-side-panel">
        <div class="text-items">
            <h1>
                {{ 'LOG_INTO_TITLE' | translate }}
            </h1>

            <p class="text-items__description">
                <span style="padding-right: 3px">{{ 'LOG_INTO_DESCRIPTION' | translate }}</span>
                <a
                    *ngIf="registerLink"
                    [routerLink]="'/register' | localize"
                    class="link link--action link--emphasized"
                    >{{ 'LOG_INTO_CREATE_AN_ACCOUNT_LINK' | translate }}</a
                >
            </p>
        </div>
    </div>
</aside>

<ng-container *ngIf="env.USE_TAILWIND">
    <div class="word-break">
        <h1 class="mb-5 text-5xl leading-tight lg:text-6xl">
            {{ 'LOG_INTO_TITLE' | translate }}
        </h1>

        <p>
            <span class="mr-1">{{ 'LOG_INTO_DESCRIPTION' | translate }}</span>
            <a *ngIf="registerLink" [routerLink]="'/register' | localize" class="pn-light:text-primary text-secondary">
                {{ 'LOG_INTO_CREATE_AN_ACCOUNT_LINK' | translate }}
            </a>
        </p>
    </div>
</ng-container>
